export class Plugins {
    constructor () {
        this.select = 'select:not(default)';
        this.forms = 'form[data-validate]';
    }

    init () {
        // svg4everybody(); // eslint-disable-line
        this.foundation();
        this.validator();
    }

    foundation () {
        $(document).foundation();
    }

    validator () {
        if (!$(this.forms).length) return;

        window.Parsley.addValidator('requiredOptionTrue', {
            validateString: function (value) {
                return value === 'true';
            },
            excluded: '[disabled]',
            messages: {
                en: window.Resources && window.Resources.payments ? window.Resources.payments.mandatoryField : ''
            }
        });

        $(this.forms).each((i, form) => {
            $(form).parsley({
                errorClass: 'is-invalid-input',
                successClass: 'is-valid-input',
                errorsWrapper: '<div class="errors-list"></div>',
                errorTemplate: '<span class="form-error is-visible"></span>',
                focus: 'none'
            }).on('field:error', e => {
                $('.login-form-error').empty();
                $('.login-form-error').removeClass('login-form-error-block');

                if (e.$element.closest('.form-group').hasClass('error-inside')) {
                    const error = e.$element.closest('.form-group').find('.errors-list');
                    error.insertAfter(e.$element.closest('.form-group').find('label').last());
                }
                if (e.$element.parents('label').hasClass('label-inside')) {
                    const error = e.$element.parents('label').find('.errors-list');
                    error.insertAfter(e.$element.parents('label'));
                }
                if (e.$element.hasClass('gender')) {
                    $('html, body').animate({
                        scrollTop: 0
                    });
                }
                const label = e.$element.parents('.form-group').find('label');
                if(!label.hasClass('dont-apply-error')) {
                    label.removeClass('is-valid-label').addClass('is-invalid-label').addClass('is-invalid-input');
                }
                $(form).find('.login-form-error').html($('#login-error-fields').html());
                $(form).find('.login-form-error').addClass('login-form-error-block');
                $(form).find('#login-form-password').val('');

                if ($(form).find('#reg-phone-error')) {
                    $(form).find('#reg-phone-error').html($('#login-error-fields').text());
                }
            }).on('field:success', e => {
                e.$element.parents('label').removeClass('is-invalid-label').addClass('is-valid-label');
                if (e.$element[0].type == 'email' && e.$element[0].className == 'is-invalid-input') {
                    $('.login-form-error').empty();
                    $('.login-form-error').removeClass('login-form-error-block');
                    e.$element.parsley().reset();
                }
            });

            $(form).find('input').on('focus', (e) => {
                const $element = $(e.currentTarget);
                if ($element.closest('.form-group').hasClass('error-inside')) {
                    $element.closest('.form-group').find('.errors-list').empty();
                }

                $element.parents('label').find('.errors-list').empty();
                $element.parents('label').addClass('is-valid-label').removeClass('is-invalid-label');
                $element.removeClass('is-invalid-input').addClass('is-valid-input');

                if ($('.page').data('action') === 'Account-RegistrationFormShow') {
                    $element.siblings('label').addClass('is-valid-label').removeClass('is-invalid-label');
                }
            });
        });
    }
}

const plugins = new Plugins();
export default plugins;
